import { combineReducers } from "redux";
import { organizationReducer } from "go-security/services/organizations/reducer";
import { sessionReducer } from "go-security/services/session/reducer";
import { userReducer } from "go-security/services/users/reducer";

export const storeReducer = combineReducers({
	user: userReducer,
	session: sessionReducer,
	organization: organizationReducer,
});
